import type {components, paths} from '../../openapi/auth.swagger';
import {axiosInstance} from '../axiosInstance';

export type PdfReferenceRequestBody = components['schemas']['PdfReferenceRequest'];
export type PdfReferenceResponseBody = components['schemas']['PdfReferenceResponse'];

type CreatePdfReferenceOperation = paths['/executor_web/self_employment/pdf_references']['post'];

export type CreatePdfReferenceRequest = NonNullable<
	NonNullable<CreatePdfReferenceOperation['requestBody']>['content']['application/json']
>;
export type CreatePdfReferenceResponse =
	CreatePdfReferenceOperation['responses'][200]['content']['application/json'];

/** POST `/executor_web/self_employment/pdf_references` — запрос справки из ФНС с отправкой на почту */
export function createPdfReference(request: CreatePdfReferenceRequest, signal?: AbortSignal) {
	return axiosInstance.post<CreatePdfReferenceResponse>('self_employment/pdf_references', request, {signal});
}
